const popup = document.querySelector(".popup-add-to-cart");

if (popup) {
    const closeElements = popup.querySelectorAll(".js-close-popup");

    if (closeElements.length > 0) {
        closeElements.forEach(element => element.addEventListener("click", () => popup.classList.remove("-active")));
    }
}